import script from "./ColorOption.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorOption.vue?vue&type=script&setup=true&lang=js"

import "./ColorOption.vue?vue&type=style&index=0&id=f4b3e612&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4b3e612"]])

export default __exports__